import { useSigningState } from '@modusign/react-signing/setup';
import { useDispatch } from 'react-redux';

import { toSigningStateForSetup } from '@app/features/apply-react-signing/libs/signing-mapper';
import { getEmbeddedDraft } from '@app/features/integration/embeddedDraft/lib/getEmbeddedDraft';
import { resetEmbeddedDraftPreview } from '@app/features/integration/embeddedDraftPreview';
import { usePDF } from '@app/hooks/usePDF';
import { getFileFromURL } from '@app/store/transport-layer/files';

export function useSetupPreviewByEmbeddedDraft() {
  const dispatch = useDispatch();
  const { initialize } = useSigningState();

  const { setPDF, resetPDF } = usePDF();

  async function load({ draftId }: { draftId: string }) {
    try {
      resetPDF();
      const draft = await getEmbeddedDraft(draftId);

      if (!draft.file) {
        throw new Error('초안에 지정된 파일이 없습니다.');
      }

      const { data: pdf } = await getFileFromURL(draft.file.url);
      setPDF(pdf);

      const signingState = toSigningStateForSetup(
        draft.attachments,
        draft.participants,
        draft.fields,
        // TODO: (@Juyeong-Byeon) getNewDraftById api 에서 스펙과 다르게 null로 주고 있음. 이부분 해결 필요,
        draft.fieldGroups ?? [],
        draft.verifications
      );

      // (@Juyeong-Byeon) embedded preview에서는 requester의 필드만 보여주는 것이 정책이라서 필터링 후 초기화
      signingState.participants = signingState.participants.filter((p) => p.type === 'REQUESTER');
      signingState.fields = signingState.fields.filter((field) =>
        signingState.participants.some((p) => p.id === field.participantId)
      );

      initialize({
        attachments: signingState.attachments,
        fields: signingState.fields,
        verifications: signingState.verifications,
        participants: signingState.participants,
        document: {
          pdfFile: draft.file,
          title: draft.title ?? '',
          pdfPassword: draft.pdfPassword,
        },
      });
    } catch (e) {
      dispatch(resetEmbeddedDraftPreview());
      throw e;
    }
  }

  return {
    load,
  };
}
